import { defineMessages } from "react-intl";

export const messages = defineMessages({
  noneTitle: {
    id: "backgroundImageItem.none.title",
    defaultMessage: "None",
    description: "Title for none filter",
  },
  blurTitle: {
    id: "backgroundImageItem.blur.title",
    defaultMessage: "Blur",
    description: "Title for blur filter",
  },
});
